/**
 * 和服务端进行交互
 *  它封装了全局 request拦截器、respone拦截器、统一的错误处理、统一做了超时，baseURL设置等
 * <pre>
 * 作者:wei yang
 * 邮箱:1205181727@qq.com
 * 日期:2015-11-02-下午3:29:34
 * 版权:广州百拓开源信息科技有限公司
 * </pre>
 */
import axios from 'axios'
import Qs from 'qs'
// import '@/mock/mock'
// eslint-disable-next-line
import { Message } from 'element-ui'
// eslint-disable-next-line
import I18n from '@/utils/i18n' // Internationalization 国际化
import Utils from '@/utils/util'
import { parseTime } from '@/utils'
import router from '@/router'
// 验权
import { getToken } from '@/utils/auth'
import store from '@/store'
// import { refreshAccessToken } from '@/api/oauth2/user'

import { tryHideFullScreenLoading, NProgressStartLoading, NProgressEndLoading } from './loading'

import requestCode from '@/constants/state'
// const HEADER_TOKEN_KEY = process.env.VUE_APP_TOKEN_KEY // header 请求的token key
const TIMEOUT = 3000 * 200 // 请求超时（timeout）时间
/**
 * 创建axios实例
 */
const service = axios.create({
  timeout: TIMEOUT, // request timeout
  withCredentials: true, //  跨域安全策略，
  baseURL: '',
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json;charset=utf-8'
  }
})

const pengdingRequest = new Map()

// 根据当前请求信息，生成请求 key
function generateReqKey(config) {
  const { method, url, params, data } = config
  const formdata = {}
  if (data instanceof FormData) {
    for (const [key, val] of data.entries()) {
      formdata[key] = val
    }
  }
  return [method, url, JSON.stringify(params), JSON.stringify(data), JSON.stringify(formdata)].join('&')
}

// 把当前请求信息添加到 pengdingRequest 对象中
function addPendingRequset(config) {
  const reqKey = generateReqKey(config)
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken((cancel) => {
      if (!pengdingRequest.has(reqKey)) {
        pengdingRequest.set(reqKey, cancel)
      }
    })
}

// 检查是否存在重复请求，若存在取消请求
function removePendingRequest(config, type) {
  const reqKey = generateReqKey(config)
  if (pengdingRequest.has(reqKey)) {
    // 如果是请求时有重复，需要取消请求
    if (type === 1) {
      console.log('取消----', type, reqKey)
      const cancelToken = pengdingRequest.get(reqKey)
      cancelToken()
    }
    pengdingRequest.delete(reqKey)
  }
}

export function clearPending() {
  for (const [key, cancelToken] of pengdingRequest) {
    cancelToken()
  }
  pengdingRequest.clear()
  console.log(pengdingRequest.size)
}

/**
 * 请求(request)拦截器
 *
 *  get 请求  统一参数放在params里面 // 后台对应只有@RequestParam
 *      // `params` 是即将与请求一起发送的 URL 参数
 *     // 必须是一个无格式对象(plain object)或 URLSearchParams 对象
 *  post 请求 统一参数放在data里面    // json 格式 后台对应@RequestBody ,其他 后台对应@RequestParam
 *   === // `data` 是作为请求主体被发送的数据
 *     // 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
 *    // 在没有设置 `transformRequest` 时，必须是以下类型之一：
 *    // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
 *     // - 浏览器专属：FormData, File, Blob
 *     // - Node 专属： Stream
 *   ==// post 请求 `params`  这个同get 但要注意  后台对应@RequestParam 请求的`Content-Type`是 application/x-www-form-urlencoded 用 qs.stringify 去构造数据
 */
service.interceptors.request.use(
  async config => {
    // removePendingRequest(config, 1)
    // addPendingRequset(config)
    if ((config.url.indexOf('login') > 0 || config.headers['needFormat']) && config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = Qs.stringify(config.data, {
        serializeDate: date => {
          // 处理qs中date时间格式，转换为中国时区时间
          return parseTime(date)
        },
        arrayFormat: 'repeat'
      })
    }
    // 去除查询条件的前后空格
    if (config.data) {
      if (!Array.isArray(config.data) && (typeof config.data === 'object')) {
        for (const key in config.data) {
          if (typeof config.data[key] === 'string') {
            config.data[key] = config.data[key].trim()
          }
        }
      }
    }
    // 防止缓存
    if (config.method.toUpperCase() === 'GET') {
      config.params = {
        ...config.params,
        _t: Date.parse(new Date()) / 1000
      }
    }
    if (!config.headers['X-Auth-Token'] && store.getters.token) {
      config.headers['X-Auth-Token'] = getToken()
    }
    NProgressStartLoading()
    return config
  },
  error => {
    // pengdingRequest.clear()
    tryHideFullScreenLoading()
    NProgressEndLoading()
    Promise.reject(error)
  }
)

/**
 * 响应(respone)拦截器
 */
service.interceptors.response.use(
  async response => {
    // removePendingRequest(response.config, 2)
    // console.log('response', response)
    tryHideFullScreenLoading()
    // stream形式
    if (response.data instanceof Blob) {
      const contentDisposition = response.headers['content-disposition']
      let name = 'document'
      if (contentDisposition) {
        try {
          name = decodeURIComponent(contentDisposition.split('=')[1]).replaceAll('"', '')
        } catch (error) {
          console.warn('Failed to parse content-disposition header:', error)
        }
      }
      return {
        data: response.data,
        type: response.headers['content-type'],
        name: name
      }
    }
    const dataAxios = response.data
    const { status, message, msg, data } = dataAxios
    // 处理获取token 第三方页面需要的
    if (response.config.url.indexOf('platform/getClientByApp') !== -1 || response.config.url.indexOf('wantGoodsDataQuery/thirdRealTimeInventory') !== -1) {
      NProgressEndLoading()
      return dataAxios
    }
    // scm接口
    if (response.config.url.indexOf('scm') !== -1) {
      NProgressEndLoading()
      return dataAxios
    }
    if (response.config.responseType === 'arraybuffer') {
      // 刷新tonken
      NProgressEndLoading()
      return response
    }
    // 如果没有 code 代表这不是项目后端开发的接口 比如可能是请求最新版本,或者是请求的数据，或者是
    if (status === undefined) {
      const message = '接口异常，没有返回[code]参数</br>' + response.config.url
      Message.closeAll()
      Message({
        message: `${message}`,
        type: 'error',
        showClose: true,
        dangerouslyUseHTMLString: true,
        duration: 5 * 1000
      })
      NProgressEndLoading()
      return
    }
    if (status === requestCode.UNAUTHORIZED) {
      Message.closeAll()
      Message({
        message: `${msg}`,
        type: 'error',
        showClose: true,
        dangerouslyUseHTMLString: true,
        duration: 5 * 1000
      })
      await store.dispatch('permission/resetToken')
      router.replace('/login')
      NProgressEndLoading()
      return
    }
    // code为200是正确的请求  或者  验证码问题,或者警告类型的错误 自行处理
    if (
      status == requestCode.TOPSUN_SUCCESS ||
      status == requestCode.TOPSUN_SUCCESS_TIP ||
      // status === requestCode.TOPSUN_ERROR ||
      status == requestCode.UNSUPORT ||
      status == requestCode.WARN
    ) {
      NProgressEndLoading()
      return dataAxios
    }
    if (status == requestCode.TOPSUN_ERROR) {
      Message.closeAll()
      Message.error(message || msg)
      dataAxios.status = 0
      NProgressEndLoading()
      return dataAxios
    }
    // 错误处理
    let errorMsg = ''
    if (Utils.isNotEmpty(message)) {
      // 有错误消息
      errorMsg = Utils.isNotEmpty(dataAxios)
        ? I18n.t('error.messageCause', {
          message: message || msg,
          cause: dataAxios
        })
        : I18n.t('error.message', {
          message: message || msg
        })
    } else if (Utils.isNotEmpty(data)) {
      // 只有错误原因
      errorMsg = I18n.t('error.cause', {
        data
      })
    } else if (
      I18n.t('error.message', {
        message: message || msg
      })
    ) {
      // 有错误编码
      errorMsg = I18n.t('error.status' + status)
    } else {
      // 未知
      errorMsg =
        message || msg ||
        I18n.t('error.unknown', {
          status
        })
    }
    Message.closeAll()
    Message({
      message: `${errorMsg}`,
      type: 'error',
      showClose: true,
      dangerouslyUseHTMLString: true,
      duration: 5 * 1000
    })
    const err = new Error(errorMsg)
    err.code = status
    err.cause = data
    NProgressEndLoading()
    return Promise.reject(err)
  },
  // 异常处理
  async error => {
    // removePendingRequest(error.config || {}, 3)
    tryHideFullScreenLoading()
    if (`${error}`.indexOf('401') !== -1) {
      Message.closeAll()
      Message.error('登录用户失效，请重新登录！')
      await store.dispatch('permission/resetToken')
      store.commit('permission/RESET_ROUTES')
      store.commit('permission/RESET_BUTTONS')
      store.commit('user/SET_CHECKEROLE', 0)
      setTimeout(() => {
        router.replace('/login')
      }, 0)
      return
    }
    if (error.request?.status === 413) {
      Message.error('上传文件过大！')
    }
    NProgressEndLoading()
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js